/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateDocumentFolderRequestDocumentFolderFromJSON, CreateDocumentFolderRequestDocumentFolderToJSON } from './CreateDocumentFolderRequestDocumentFolder';
export function UpdateDocumentFolderRequestFromJSON(json) {
    return UpdateDocumentFolderRequestFromJSONTyped(json, false);
}
export function UpdateDocumentFolderRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentFolder: CreateDocumentFolderRequestDocumentFolderFromJSON(json['document_folder'])
    };
}
export function UpdateDocumentFolderRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_folder: CreateDocumentFolderRequestDocumentFolderToJSON(value.documentFolder)
    };
}
